import React from 'react';
import { Gift, Check } from 'lucide-react';
const bonuses = [{
  num: '01',
  emoji: '🎵',
  title: 'Playlists Curadas por Emoción',
  desc: '6 playlists completas con BPM específico por tomo. La música correcta para cada clase sin buscar nada.',
  value: 'USD 12'
}, {
  num: '02',
  emoji: '📋',
  title: 'Ficha de Anamnesis Profesional',
  desc: 'Formulario completo, ficha express, ficha para adultos mayores y consentimiento informado editable.',
  value: 'USD 9'
}, {
  num: '03',
  emoji: '🎯',
  title: 'Guía de Variaciones en 3 Niveles',
  desc: '14 ejercicios clave del sistema en versión Fundacional, Estándar y Avanzada — la misma clase para cualquier grupo.',
  value: 'USD 8'
}, {
  num: '04',
  emoji: '📅',
  title: 'Calendario Anual de Planificación',
  desc: '12 meses organizados semana a semana. Qué tomo, qué clase y qué meta cada semana del año.',
  value: 'USD 10'
}, {
  num: '05',
  emoji: '💬',
  title: 'Script de Primera Clase',
  desc: 'Qué decir exactamente en los 5 momentos clave de la primera clase para que la alumna nueva se quede y pague el mes.',
  value: 'USD 9'
}, {
  num: '06',
  emoji: '📱',
  title: 'Pack de Flyers para Redes',
  desc: '18 diseños editables en Canva + calendario de 30 días de contenido listo para publicar en WhatsApp e Instagram.',
  value: 'USD 8'
}];
export function BonusSection() {
  return <section className="w-full bg-bg-main py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-28">
      <div className="absolute top-1/4 left-0 w-[400px] h-[400px] bg-secondary/8 rounded-full blur-[120px] pointer-events-none hidden sm:block" data-id="element-29"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-30">
        <div className="text-center mb-10 sm:mb-14" data-id="element-31">
          <p className="inline-flex items-center gap-1.5 bg-secondary/15 text-secondary font-bold uppercase tracking-wider text-[11px] sm:text-xs px-3 py-1.5 rounded-full border border-secondary/25 mb-4" data-id="element-32">
            <Gift className="w-3.5 h-3.5" data-id="element-33" />6 Bonos estratégicos
          </p>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-34">
            Y además, recibes{' '}
            <span className="text-secondary" data-id="element-35">6 bonos exclusivos</span>.
          </h2>
          <p className="text-text-sec text-base sm:text-lg max-w-2xl mx-auto" data-id="element-36">
            Valor total de los bonos:{' '}
            <span className="text-badge-red font-black line-through" data-id="element-37">
              USD 56
            </span>{' '}
            <span className="text-cta-green font-black" data-id="element-38">
              → Hoy: GRATIS con el Kit
            </span>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5" data-id="element-39">
          {bonuses.map((bonus, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light p-5 sm:p-6 flex items-start gap-4 sm:gap-5 relative transition-all hover:-translate-y-1 hover:border-secondary/40 hover:shadow-[0_14px_32px_-12px_rgba(212,165,116,0.3)] shadow-[0_4px_18px_-10px_rgba(90,70,120,0.12)]" data-id="element-40">
              {/* Number ghost */}
              <span className="absolute top-3 right-4 text-secondary/20 font-black text-2xl sm:text-3xl leading-none select-none" data-id="element-41">
                {bonus.num}
              </span>

              {/* Emoji */}
              <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-2xl bg-gradient-to-br from-secondary/25 to-secondary/5 border border-secondary/25 flex items-center justify-center flex-shrink-0 text-2xl sm:text-3xl shadow-inner" data-id="element-42">
                {bonus.emoji}
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0" data-id="element-43">
                <h3 className="text-text-main font-black text-base sm:text-lg leading-tight mb-1" data-id="element-44">
                  {bonus.title}
                </h3>
                <p className="text-text-sec text-xs sm:text-sm font-medium mb-2" data-id="element-45">
                  Valor:{' '}
                  <span className="text-text-main font-bold line-through" data-id="element-46">
                    {bonus.value}
                  </span>{' '}
                  ·{' '}
                  <span className="inline-flex items-center gap-1 text-cta-green font-black" data-id="element-47">
                    <Check className="w-3 h-3" data-id="element-48" />
                    GRATIS
                  </span>
                </p>
                <p className="text-text-sec text-sm leading-relaxed" data-id="element-49">
                  {bonus.desc}
                </p>
              </div>
            </div>)}
        </div>

        {/* Total reinforcement */}
        <div className="mt-10 sm:mt-12 bg-gradient-to-br from-secondary/10 via-bg-alt to-secondary/5 border border-secondary/25 rounded-2xl p-6 sm:p-8 text-center" data-id="element-50">
          <p className="text-text-sec text-sm sm:text-base font-medium mb-1" data-id="element-51">
            Si compraras estos 6 bonos por separado:
          </p>
          <p className="text-text-main font-black text-2xl sm:text-3xl" data-id="element-52">
            <span className="text-badge-red line-through" data-id="element-53">USD 56</span>{' '}
            <span className="text-secondary ml-2" data-id="element-54">→ Incluidos sin costo</span>
          </p>
        </div>
      </div>
    </section>;
}